import type { ActionType, ProColumns } from '@ant-design/pro-table';
import { Space, message, Button, TreeDataNode, DatePicker } from 'antd';
import { useRef, useCallback, useState } from 'react';
import { PageContainer, useAPI } from '@fregata/shared';
import { Link, useNavigate } from 'react-router-dom';
import { ProTable } from '@ant-design/pro-table';
import { ModalForm } from '@ant-design/pro-form';
import { FormLayout } from 'antd/lib/form/Form';
import useRequest from '@ahooksjs/use-request';
import OutletLayout from 'layouts/OutletLayout';
import moment from 'moment';
import { disabledDate } from 'utils/disableDate';
const LAYOUT_TYPE_HORIZONTAL = 'horizontal';

const categoryValueEnum = {
  0: '登录成功',
  1: '登录失败',
  2: '退出登录',
  3: '单点登录成功',
  4: '移动端扫码登录',
  5: '其他',
};

const UserAction = () => {
  const [formLayoutType] = useState<FormLayout>(LAYOUT_TYPE_HORIZONTAL);
  const ref = useRef<ActionType>();
  const navigate = useNavigate();
  const { api } = useAPI();

  const [recordCount, setRecordCount] = useState<any>();

  // 列名
  let baseColumns: ProColumns[] = [
    {
      title: '账号',
      dataIndex: 'userId',
      hideInSearch: true,
    },
    {
      title: '用户名称',
      dataIndex: 'userName',
      search: {
        transform: (v) => ({ queryName: v }),
      },
    },
    {
      title: '所属企业',
      dataIndex: 'teamName',
      hideInSearch: true,
    },
    {
      title: '应用名称',
      dataIndex: 'displayName',
      hideInSearch: true,
    },
    {
      title: '操作类型',
      dataIndex: 'targetType',
      hideInSearch: true,
    },
    // {
    //   title: '操作状态',
    //   dataIndex: 'state',
    //   renderText: (value) => categoryValueEnum[value],
    // },
    // {
    //   title: '请求方式',
    //   dataIndex: 'state',
    //   hideInSearch: true,
    //   renderText: (value) => categoryValueEnum[value],
    // },
    {
      title: '操作内容',
      dataIndex: 'content',
      hideInSearch: true,
      renderText: (value) => {
        return value?.replace(/<[^>]+>/g, '');
      },
    },
    {
      title: '操作时间',
      dataIndex: 'createTime',
      valueType: 'dateRange',
      hideInTable: true,
      hideInForm: true,
      search: {
        transform: (value) => {
          return {
            startDate: value[0],
            endDate: value[1],
          };
        },
      },
      formItemProps: () => {
        return {
          initialValue: [moment().subtract(30, 'days'), moment()],
        };
      },
      renderFormItem: () => {
        return <DatePicker.RangePicker disabledDate={disabledDate} placeholder={['请选择', '请选择']}/>;
      },
    },
    {
      title: '操作时间',
      dataIndex: 'createdAt',
      hideInSearch: true,
      hideInForm: true,
      renderText: (value) => {
        return moment(value).format('YYYY-MM-DD hh:mm:ss');
      },
    },
  ];

  // 获取表格内容数据
  const requestData = useCallback(
    async ({ current, ...params } = {}) => {
      return api('/api/collect-store/coding_manage/page_operation_log_list', {
        handleResponse2Data: false,
        params: { pageNum: current, ...params },
      }).then((resp: any) => {
        console.log('获取表格内容数据resprespresp', resp);

        // 总用户数：
        setRecordCount(resp.data.total);

        let returnData = { data: resp.data.list, success: resp.message, total: resp.data.total };
        return returnData;
      }) as any;
    },
    [api]
  );

  return (
    <>
      <PageContainer isBody>
        <ProTable
          dateFormatter='string'
          rowKey='id'
          scroll={{ x: 1600 }}
          columns={baseColumns}
          actionRef={ref}
          request={requestData}
          tableAlertRender={false}
          tableAlertOptionRender={false}
          editable={{
            type: 'multiple',
          }}
          search={{
            labelWidth: 'auto',
          }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: 10, // 默认10条/页
          }}
          headerTitle={
            <Space>
              <span>船海智云开发者操作日志列表</span>
              <span style={{ color: '#1b62b7' }}>[总记录数：{recordCount}]</span>
            </Space>
          }
        />
      </PageContainer>

      <OutletLayout context={{ reload: ref.current?.reload }} />
    </>
  );
};

export default UserAction;
